export default "/images/CONFEX2.png?38e27823d8d614f6ca90ac733ef10633";